//
// ALL FORM & INPUT VALIDATION EXPORTED FROM THIS FILE
//

// function which returns true if form content is valid
export function validateForm(content) {
  return content.length > 0;
}

export function validate_adform_url(adformTaggingInput, isMandatory) {
  if (adformTaggingInput === "") return { value: adformTaggingInput, valid: !isMandatory, errorMessage: isMandatory ? "Input is required" : "" };
  if (adformTaggingInput.slice(0, 8) !== "https://") return { value: adformTaggingInput, valid: false, errorMessage: "Error: input must be a valid url that starts with 'https://'." };
  // The below must be the final check - as it can still return true (warning rather than an error message) - KT 11.05.22
  if (adformTaggingInput.includes(`"`) || adformTaggingInput.includes(`'`)) return { value: adformTaggingInput, valid: true, errorMessage: `Warning: url contains " or ' characters. Only continue if you are sure url is correct.` };
  return { value: adformTaggingInput, valid: true, errorMessage: `` };
}
